import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import DataObject from '@mui/icons-material/DataObject';
import DynamicFormIcon from '@mui/icons-material/DynamicForm';

import DynamicForm from '../../../components/dynamicForm/DynamicForm';
import { MultiLanguageEditor } from '../../../components/others/MultiLanguageEditor';
import { KendoTreeList } from '../components/KendoTreeList';
import { useTranslation } from 'react-i18next';
import { ActionButtons } from '../../../components/others/ActionButtons';
import { DialogActions } from '@mui/material';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role='tabpanel'
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const FlowEditor = ({
    open,
    data,
    scheme,
    setOpen,
    handleSave
}) => {
    const { t } = useTranslation();
    const isParser = data.type_component === 'parser' || data.type_component === 'decision';
    const [valueTab, setValueTab] = useState(
        scheme.length > 0 || isParser ? 0 : 1
    );
    const [contentJson, setContentJson] = useState(data.body);

    const OnChengeSetValue = (event, newValue) => setValueTab(newValue);
    const setNewValue = (data) => setContentJson(prev => ({ ...prev, ...data }));
    const setChanges = (name, value) => setContentJson(prev => ({ ...prev, [name]: value, }));

    const onChange = (e) => {
        const { name, value, type, checked } = e.target;
        setContentJson({ ...contentJson, [name]: type === 'checkbox' ? checked : value });
    }

    const onSave = () => {
        handleSave(contentJson, data.order);
        setOpen(false);
    }

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth='xl'
            PaperProps={{
                style: { height: '95%', overflow: 'visible' }
            }}
        >
            <DialogTitle>
                <Typography variant='h5' component='h5'>
                    Edit flow component
                </Typography>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex' }}>
                    <Tabs
                        sx={{ width: '70%' }}
                        value={valueTab}
                        onChange={OnChengeSetValue}
                        aria-label='basic tabs example'
                    >
                        <Tab icon={<DynamicFormIcon color='info' />} label={t("viewAsForm")} />
                        <Tab icon={<DataObject color='success' />} label={t("viewAsJson")} />
                    </Tabs>
                </Box>
            </DialogTitle>
            <DialogContent>
                <TabPanel value={valueTab} index={0}>
                    {
                        isParser ?
                            <KendoTreeList
                                data={contentJson}
                                typeComponent={data.type_component}
                                setValue={setContentJson}
                            />
                            :
                            <DynamicForm
                                values={contentJson}
                                scheme={scheme}
                                errorInputs={{}}
                                onChange={onChange}
                                setChanges={setChanges}
                            />
                    }
                </TabPanel>
                <TabPanel value={valueTab} index={1} height={1200}>
                    <MultiLanguageEditor
                        value={contentJson}
                        dfLanguage={'json'}
                        onChange={setNewValue}
                        errorInputs={{}}
                        field={{
                            id: data.order,
                            label: data.description + ":"
                        }}
                    />
                </TabPanel>
            </DialogContent>
            <DialogActions>
                <ActionButtons
                    onCancel={() => setOpen(false)}
                    onSubmit={onSave}
                />
            </DialogActions>
        </Dialog>
    );
}

export default FlowEditor;